import { jsx as _jsx } from "react/jsx-runtime";
import ObjectCard from '@widget/list/ObjectCard/ObjectCard';
import usePressGesture from '@hooks/touch/usePressGesture';
/**
 * A library file or gallery photo in the picker's list. Web: a click previews, the checkbox ticks.
 * Phones (multiple mode): hold to tick; once something is ticked a tap ticks too, and the
 * checkboxes show.
 */
const MediaPickCard = (props) => {
    const { layout, image, icon, title, description, selected, active, onPreview, onToggle, isMobile, selectMode } = props;
    const gestures = usePressGesture({
        onLongPress: isMobile && onToggle ? () => { if (!selected)
            onToggle(); } : undefined,
    });
    return _jsx("div", Object.assign({ className: "uxpcore_mediapicker__card" }, gestures.handlers, { children: _jsx(ObjectCard, { layout: layout, image: image, icon: icon, title: title, description: description, selected: selected, onSelect: onToggle && (!isMobile || selectMode) ? () => onToggle() : undefined, active: active, onClick: () => {
                if (gestures.consumeClick())
                    return;
                if (isMobile && selectMode && onToggle)
                    onToggle();
                else
                    onPreview();
            } }) }));
};
export default MediaPickCard;
